export default function initEmailSpeedbump() {
  const mailtoLinks = document.querySelectorAll<HTMLAnchorElement>(
    'a[href^="mailto"]'
  )

  const handleMailtoClick = (event: Event) => {
    let emailSpeedbumpText = document.getElementById('email-speedbump-text')?.textContent

    if (!emailSpeedbumpText) {
      emailSpeedbumpText = `Please do not include sensitive information in your email message as it is not a secure way to transmit communication. You may use secure messaging within online banking or you may contact one of our Citizens Bank of Edmond team members at (405) 341-6650 to discuss details of your account.`;
    }

    const confirmed = confirm(
      emailSpeedbumpText
    )
    if (!confirmed) {
      event.preventDefault()
    }
  }

  mailtoLinks.forEach((link) => {
    link.addEventListener('click', handleMailtoClick)
  })
}